import {
    STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_SUCCESS,
    STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getCarLotsDataMasterPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                carLotsOptions: [],
                carLotsOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_SUCCESS:
        const carLotsDefaultValue = action.data.carLotsDefault || state.takingCarManagement.fastStockLoading.carLotsDefault
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getCarLotsDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                carLotsOptions: action.data.carLotsList,
                carLotsDefault : carLotsDefaultValue,
                carLotsOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getCarLotssDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                carLotsOptions: [],
                carLotsOptionsError: action.data.error
            }
          }
        }
      default:
        return state
    }
  }
  